import { addNamespaceInOperations } from '../helper'

export const ACTIONS_METHODS = {
}

export const actions = {
}

export const ACTIONS = addNamespaceInOperations('design', ACTIONS_METHODS)
